import PropTypes from 'prop-types';
import '../../../../../../components/src/lib/AppLayout/HorDefault/AppHeader/custom_styles.sass';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';

const BreadCrumbsUi = ({ path, companyData }) => {//NOSONAR
  const { verbiageSettings } = useApplicationSettings();
  const fullUrl = window.location.href;
  const parsedUrl = new URL(fullUrl);
  const parts = fullUrl.split('/');
  let name = parts[parts.length - 1];
  const pathName = parsedUrl?.pathname;
  const containsProductDetails = pathName?.includes('/product-details');
  const containsPackageDetails = pathName?.includes('/package-details');
  const productBgImage = localStorage.getItem('image');
  const packageBgImage = localStorage.getItem('packageImage');
  if (!containsProductDetails) {
    localStorage.removeItem('image');
  }
  if (!containsPackageDetails) {
    localStorage.removeItem('packageImage');
  }
  if (parts?.includes('product-listing') || parts?.includes('service')) {
    name = verbiageSettings?.product_type || 'Products';
  } else if (parts?.includes('waiversettings')) {
    name = `${verbiageSettings?.waiver_name || 'Waiver'}Settings`;
  } else if (parts?.includes('products')) {
    name = verbiageSettings?.product_type || 'Products';
  } else if (parts?.includes('product-type-settings')) {
    name = `${verbiageSettings?.product_type || 'Product'}-type-settings`;
  } else if (parts?.includes('conveniencefee')) {
    name = verbiageSettings.convenience_fee_alias || 'conveniencefee';
  } else if (parts?.includes('waiver')) {
    name = verbiageSettings?.waiver_name || 'waiver';
  } else if (parts?.includes('add-products')) {
    name = `add-${verbiageSettings?.product_type || 'products'}`;
  } else if (parts?.includes('dashboard')) {
    name = verbiageSettings?.my_locker_alias || 'dashboard';
  } else if (parts?.includes('edit-activity')) {
    name = 'Acivities';
  } else if (parts?.includes('edit-session')) {
    name = 'Sessions';
  } else if (parts?.includes('package')) {
    name = 'Packages';
  } else if (path?.includes('signin')) {
    name = 'Sign In';
  } else if (path?.includes('checkout')) {
    name = 'Checkout';
  } else if (path?.includes('order') && path?.includes('confirmation')) {
    name = 'Order confirmation';
  }
  let imageSrc;

  if (path.includes('settings')) {
    imageSrc = '/assets/images/admincompanysettings.png';
  } else if (path.includes('edit-activity') || path.includes('edit-session')) {
    imageSrc = '/assets/images/activitySessions.png';
  }

  let bannerSrc = null;

  if (path !== '/home' && !productBgImage && !packageBgImage) {
    if (companyData.home_banner_url) {
      bannerSrc = `${process.env.NX_CLOUD_FRONT_URL}/${companyData.home_banner_url}`;
    } else {
      bannerSrc = '/assets/images/Membertraxx_background.png';
    }
  } else if (productBgImage) {
    bannerSrc = `${process.env.NX_CLOUD_FRONT_URL}/${productBgImage}`;
  } else if (packageBgImage) {
    bannerSrc = `${process.env.NX_CLOUD_FRONT_URL}/${packageBgImage}`;
  }
  

  return (
    <div className={path !== '/home' ? 'breadcrumb-img' : 'home-banner'}>
      <span className="breadcrumb-name">{name}{imageSrc}</span>
    {bannerSrc && (
        <img
          src={bannerSrc}
          alt="background"
          width="100%"
          className="bread-img"
        />
      )}
      <span className='subheader-transparent'></span>
    </div>
  );
};

export default BreadCrumbsUi;
BreadCrumbsUi.propTypes = {
  path: PropTypes.func,
  companyData: PropTypes.func,
};
